import { useEffect, useRef } from 'react';

// rAF play loop shared by Timeline and StepStrip.
// localTime accumulates inside the closure so we never read stale React state.
export default function usePlayback(active, currentTime, endTime, onTimeChange, onEnd) {
    const rafRef  = useRef(null);
    const prevRef = useRef(null);

    useEffect(() => {
        if (!active) {
            if (rafRef.current) cancelAnimationFrame(rafRef.current);
            prevRef.current = null;
            return;
        }

        let localTime = currentTime; // snapshot when play starts

        const tick = (now) => {
            if (prevRef.current === null) prevRef.current = now;
            const dt = (now - prevRef.current) / 1000;
            prevRef.current = now;
            localTime += dt;
            if (localTime >= endTime) {
                onTimeChange(endTime);
                onEnd();
                return;
            }
            onTimeChange(localTime);
            rafRef.current = requestAnimationFrame(tick);
        };

        rafRef.current = requestAnimationFrame(tick);
        return () => { if (rafRef.current) cancelAnimationFrame(rafRef.current); prevRef.current = null; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [active, endTime]);
}
